export const createSetEqnuiryCountDataAction = data => ({
  type: "Data/SetEnquiryCountData",
  data
});
export const createSetMovementsDataAction = data => ({
  type: "Data/SetMovementsData",
  data
});
export const createSetDefaultWorkDataAction = data => ({
  type: "Data/SetDefaultWorkData",
  data
});
export const createSetServicePacksDataAction = data => ({
  type: "Data/SetServicePacksData",
  data
});
export const createSetExistingJobData = data => ({
  type: "Data/SetExistingJobData",
  data
})
export const createSetJobWorkshopConfigData = data => ({
  type: "Data/SetJobWorkshopConfigData",
  data
});
export const createSetUtilsDataAction = data => ({
    type: "Data/SetUtilsData",
    data
});
export const createSetFitterHourDataAction = data => ({
  type: "Data/SetFitterHourData",
  data
});
export const createSetMovementDataAction = data => ({
  type: "Data/SetMovementData",
  data
});
export const createSetSummaryFiguresDataAction = data => ({
  type: "Data/SetSummaryFiguresData",
  data
});
export const createSetInvoiceFiguresDataAction = data => ({
  type: "Data/SetInvoiceFiguresData",
  data
});
export const createSetTrackingCategoryDataAction = data => ({
  type: "Data/SetTrackingCategoryData",
  data
});
export const createSetTrackingOptionDataAction = data => ({
  type: "Data/SetTrackingOptionData",
  data
});
export const createSetDriversDataAction = data => ({
  type: "Data/SetDriversData",
  data
});
export const createSetNominalCodesDataAction = data => ({
  type: "Data/SetNominalCodesData",
  data
});
export const createSetPartOrdersData = data => ({
  type: "Data/SetPartOrdersData",
  data
});
export const createSetPartOrderData =data => ({
  type: "Data/SetPartOrderData",
  data
});
export const createSetPartOrderFieldData = data => ({
  type: "Data/SetPartOrderFieldData",
  data
});
export const createSetPartOrderFigureData = data => ({
  type: "Data/SetPartOrderFigureData",
  data
});
export const createSetTotalsDataAction = data => ({
  type: "Data/SetTotalsData",
  data
})
export const createSetInvoicesDataAction = data => ({
  type: "Data/SetInvoicesData",
  data
});
export const createSetMovementTypesDataAction = data => ({
  type: "Data/SetMovementTypesData",
  data
});
export const createSetMovementFigureDataAction = data => ({
  type:"Data/SetMovementFigureData",
  data
});
export const createSetWorkTypeDataAction = data => ({
  type:"Data/SetWorkTypeData",
  data
});
export const createSetCreditNotesDataAction = data => ({
  type:"Data/SetCreditNotesData",
  data
});
export const createSetMovementRateDataAction = data => ({
  type:"Data/SetMovementRateData",
  data
})
export const createSetWorkServiceDataAction = data => ({
  type:"Data/SetWorkServiceData",
  data
});
export const createSetPaymentTypesDataAction = data => ({
  type:"Data/SetPaymentTypesData",
  data
});
export const createSetJobStatusCountDataAction = data => ({
  type:"Data/SetJobStatusCountData",
  data
});
export const createSetVehicleStatusCountDataAction = data => ({
  type:"Data/SetVehicleStatusCountData",
  data
});

export const createSetAppDefaultsDataAction = data => ({
  type: "Data/SetAppDefaultsData",
  data
});
export const createSetVehicleTrackerTypeDataAction = data => ({
  type: "Data/SetVehicleTrackerTypeData",
  data
});
export const createSetVehicleModelDataAction = data => ({
  type: "Data/SetVehicleModelData",
  data
})
export const createSetDefectCountDataAction = data => ({
  type: "Data/SetDefectCountData",
  data
})
export const createSetFittersDataAction = data => ({
  type: "Data/SetFittersData",
  data
});

export const createSetKeysDataAction = data => ({
  type: "Data/SetKeysData",
  data
});

export const createSetJobsDataAction = data => ({
  type: "Data/SetJobsData",
  data
});

export const createSetQuotesDataAction = data => ({
  type: "Data/SetQuotesData",
  data
});
export const createSetImagesDataAction = data => ({
  type: "Data/SetImagesData",
  data
})
export const createSetPartsDataAction = data => ({
  type: "Data/SetPartsData",
  data
});
export const createSetDepartmentsDataAction = data => ({
  type: "Data/SetDepartmentsData",
  data
})
export const createSetPartLookupDataAction = data => ({
  type: "Data/SetPartLookupData",
  data
});

export const createSetWorkLookupDataAction = data => ({
  type: "Data/SetWorkLookupData",
  data
});

export const createSetRentalsDataAction = data => ({
  type: "Data/SetRentalsData",
  data
});

export const createSetRentalInvoiceDataAction = data => ({
  type: "Data/SetRentalInvoiceData",
  data
});

export const createSetUserDataAction = data => ({
  type: "Data/SetUserData",
  data
});

export const createSetTransactionDataAction = data => ({
  type: "Data/SetTransactionData",
  data
});

export const createSetWeeklyTransactionDataAction = data => ({
  type: "Data/SetWeeklyTransactionData",
  data
});

export const createSetDataFreshAction = data => ({
  type: "DataFresh/SetDataFresh",
  dataFresh: data
});

export const createSetPartsFiguresDataAction = data => ({
  type: "Data/SetPartsFiguresData",
  data
});

export const createSetWorkFiguresDataAction = data => ({
  type: "Data/SetWorkFiguresData",
  data
});

export const createSetTransactionFiguresDataAction = data => ({
  type: "Data/SetTransactionFiguresData",
  data
});

export const createSetRentalFiguresDataAction = data => ({
  type: "Data/SetRentalFiguresData",
  data
});

export const createSetVehicleFiguresDataAction = data => ({
  type: "Data/SetVehicleFiguresData",
  data
});

export const createSetTargetFiguresDataAction = data => ({
  type: "Data/SetTargetFiguresData",
  data
});

export const createSetFixedExpenseDataAction = data => ({
  type: "Data/SetFixedExpenseData",
  data
});

export const createSetVehicleSummaryFigureDataAction = data => ({
  type: "Data/SetVehicleSummaryFigureData",
  data
})
export const createSetTargetsDataAction = data => ({
  type: "Data/SetTargetsData",
  data
});

export const createSetVehicleMakeDataAction = data => ({
  type: "Data/SetVehicleMakeData",
  data
})

export const createSetRentalMarginDataAction = data => ({
  type: "Data/SetRentalMarginData",
  data
})

export const createSetInspectionTypesDataAction = data => ({
  type: "Data/SetInspectionTypesData",
  data
});

export const createSetInspectionDataAction = data => ({
  type: "Data/SetInspectionData",
  data
});

export const createSetVehicleTypesDataAction = data => ({
  type: "Data/SetVehicleTypesData",
  data
});

export const createSetVehicleTrackerFigureDataAction = data => ({
      type: "Data/SetVehicleTrackerFigureData",
      data
});

export const createSetTransactionCategoriesDataAction = data => ({
  type: "Data/SetTransactionCategoriesData",
  data
});

export const createSetTransactionReportingCategoriesDataAction = data => ({
  type: "Data/SetTransactionReportingCategoriesData",
  data
});

export const createSetCostCentresDataAction = data => ({
  type: "Data/SetCostCentresData",
  data
});

export const createSetVehicleDataAction = data => ({
  type: "Data/SetVehicleData",
  data
});

export const createSetVehicleTrackersDataAction = data => ({
  type: "Data/SetVehicleTrackersData",
  data
});

export const createSetVehicleFieldAction = data => ({
  type: "Data/SetVehicleField",
  data
});

export const createSetRateCardsDataAction = data => ({
    type: "Data/SetRateCardsData",
    data
});

export const createSetVehicleSummaryDataAction = data => ({
  type: "Data/SetVehicleSummaryData",
  data
});

export const createSetJobFieldAction = data => ({
  type: "Data/SetJobField",
  data
});

export const createSetRentalFieldAction = data => ({
  type: "Data/SetRentalField",
  data
});

export const createSetQuoteFieldAction = data => ({
  type: "Data/SetQuoteField",
  data
});

export const createSetJobAction = data => ({
  type: "Data/SetJobData",
  data
});
export const createSetCapTotalsAction = data => ({
  type: "Data/SetCapTotalsData",
  data
});

export const createSetRentalAction = data => ({
  type: "Data/SetRentalData",
  data
});

export const createSetQuoteAction = data => ({
  type: "Data/SetQuoteData",
  data
});

export const createSetDiaryDataAction = data => ({
  type: "Data/SetDiaryData",
  data
});

export const createSetWorkDataAction = data => ({
  type: "Data/SetWorkData",
  data
});

export const createSetVehiclesDataAction = data => ({
  type: "Data/SetVehiclesData",
  data
});

export const createSetFinanceDataAction = data => ({
  type: "Data/SetFinanceData",
  data
});

export const createSetContactDataAction = data => ({
  type: "Data/SetContactData",
  data
});

export const createSetContactsDataAction = data => ({
  type: "Data/SetContactsData",
  data
});

export const createSetBlankContactDataAction = data => ({
  type: "Data/SetBlankContactData",
  data
});

export const createSetPaymentsDataAction = data => ({
  type: "Data/SetPaymentsData",
  data
});

export const createSetRecurringPaymentsDataAction = data => ({
  type: "Data/SetRecurringPaymentsData",
  data
});

export const createSetQuickLinksDataAction = data => ({
  type: "Data/SetQuickLinksData",
  data
});